import React from "react";
import { X, AlertCircle } from "lucide-react";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";

const InvalidTokenModal = ({ open, onClose, Text }) => {
  const navigate = useNavigate();
  console.log(Text);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white max-w-md w-full p-6 rounded-lg relative shadow-lg">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-sm opacity-70 hover:opacity-100 focus:outline-none"
        >
          <X className="h-4 w-4" />
        </button>

        {/* Modal Content */}
        <div className="flex flex-col items-center text-center">
          <div className="rounded-full bg-red-600 p-2 mb-4">
            <AlertCircle className="h-6 w-6 text-white" />
          </div>

          <h2 className="text-xl font-semibold mb-2 text-red-600">
            Session Expired
          </h2>

          <p className="text-gray-500">
            {Text
              ? Text
              : "Your session has expired, and you are being logged out."}
          </p>
        </div>
        <div className="flex justify-center pt-5 ">
          <Button
            className=" w-32"
            onClick={() => {
              onClose();
              navigate("/");
            }}
          >
            Login{" "}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InvalidTokenModal;
